// Lane 0 (docs/designs/observability-and-usage-metering.md): must be the
// FIRST import — before ./App — so Sentry initializes before anything else
// in the app runs, catching the earliest possible errors.
import { Sentry } from './lib/sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={() => (
        <div className="flex h-screen w-screen flex-col items-center justify-center gap-4 text-center">
          <p className="text-lg font-medium text-gray-800">Something went wrong.</p>
          <p className="text-sm text-gray-500">The error has been reported. Try reloading the page.</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded-md bg-gray-900 px-4 py-2 text-sm text-white"
          >
            Reload
          </button>
        </div>
      )}
    >
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
